module.exports = __webpack_public_path__ + "fonts/3147836.ttf";